import { ServerFetch } from '../main-model'

export default class StockVerifyCountListModel extends ServerFetch { 
    getStockVerifyCountListBy = (data) => this.authFetch({
        url: 'stock-verify-count-list/getStockVerifyCountListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    getStockVerifyCountListByCode = (data) => this.authFetch({
        url: 'stock-verify-count-list/getStockVerifyCountListByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}